import type { FC } from 'react';
import classNames from 'classnames';

import style from './style.module.scss';

interface Props extends ClassNameProp {
  name: string;
}

const MapNameTag: FC<Props> = ({ name, className }) => (
  <div className={classNames(style.mapNameTag, className)}>{name}</div>
);

MapNameTag.displayName = 'MapNameTag';

export default MapNameTag;
